import { Dispatch } from "redux";
import * as actionTypes from "../actions/types";
import { setUsersBySkill } from "../actions/profileActions";
import { FilterParams, profesionalesService } from "../../services/profesionalesService.ts";

const withLoading = async (dispatch: Dispatch, task: () => Promise<void>) => {
  dispatch({ type: actionTypes.START_LOADING });
  try {
    await task();
  } catch (error) {
    console.error(error);
  } finally {
    dispatch({ type: actionTypes.END_LOADING });
  }
};

export const fetchRegisteredProfessionals = () => async (dispatch: Dispatch) => {
  try {
    const users = await profesionalesService.fetchRegisteredUsers();
    dispatch({ type: actionTypes.USERS_REGISTERED_DATA, payload: users });
  } catch (error) {
    console.error(error);
  }
};

export const fetchFeaturedProfessionals = () => async (dispatch: Dispatch) => {
  try {
    const users = await profesionalesService.fetchFeaturedUsers();
    dispatch({ type: actionTypes.USERS_FEATURED_DATA, payload: users });
  } catch (error) {
    console.error(error);
  }
};

export const fetchProfessionalSkills = () => async (dispatch: Dispatch) => {
  try {
    const skills = await profesionalesService.fetchSkills();
    dispatch({ type: actionTypes.SET_SKILLS_LIST, payload: skills });
  } catch (error) {
    console.error(error);
  }
};

export const fetchProfessionalJurisdictions = () => async (dispatch: Dispatch) => {
  try {
    const jurisdictions = await profesionalesService.fetchJurisdictions();
    dispatch({ type: actionTypes.SET_USERS_IN_JURISDICTION, payload: jurisdictions });
  } catch (error) {
    console.error(error);
  }
};

export const fetchFilteredProfessionals = (params: FilterParams) => async (dispatch: Dispatch) => {
  await withLoading(dispatch, async () => {
    const response = await profesionalesService.fetchFilteredProfessionals(params);
    dispatch(
      setUsersBySkill(
        response.users,
        params.jurisdictionIds ?? [],
        response.itemCount,
        response.page,
        params.skillIds ?? []
      )
    );
  });
};
